<template>
    <section id="designspace" class="section">
        <div id="designprocess-anchor" style="position: relative; top: -100px; height: 0; width: 1px;"></div>
        <a-divider orientation="left" class="section-title"><b>Design Process</b></a-divider>
        <section>
            <div class="img-container">
                <img :src="'./source/image/process.png'" alt="context" width="40%">
            </div>
            <!-- <h2>1. Display of Contexts</h2>
            <div class="img-container">
                <img :src="'./source/image/context.png'" alt="context" width="60%" height="60%">
            </div> -->
        </section>
    </section>
</template>

<script>
    export default {
        name: "Process"
    }
</script>

<style scoped>
    .section {
        margin-bottom: 50px;
    }

    .section-title {
        text-align: center;
    }

    .section-title {
        flex: 0 1 85%;
        text-align: center;
        font-size: 28px;
    }

    .img-container {
        display: flex;
        justify-content: center;
        padding: 20px, 0px;
    }

    .text-container {
        text-align: justify;
        justify-content: center;
        margin-bottom: 1em; 
    }

    .text-container p {
        margin: 0px;
        width: 60%;
    }
</style>
